import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import A11yControlsClientSide from "components/A11yControls/A11yControlsClientSide";
import { Footer } from "ui/Footer";
import { TypoText, TypoTitle } from "ui/Typo";
interface ErrorTemplateProps {
  children?: ReactNode;
  title: string;
  description: string;
}
function ErrorBaseTemplate(t0) {
  const $ = _c(12);
  const {
    children,
    description,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <header className="flex p-n4 shadow-header dark:shadow-none"><A11yControlsClientSide variant="simple" className="ml-auto" /></header>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <TypoTitle className="pb-n2">{title}</TypoTitle>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <TypoText className="whitespace-pre-wrap">{description}</TypoText>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t2 || $[7] !== t3) {
    t4 = <main className="flex flex-1 flex-col items-center gap-n4 px-n8 py-n24 text-center">{t2}{t3}{children}</main>;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Footer />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <div className="flex min-h-screen w-full flex-col dark:bg-background">{t1}{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export default ErrorBaseTemplate;